<template>
  <div class="el-tabs el-tabs--top el-tabs--border-card card">
    <div class="el-tabs__header is-top" v-if="warehouses.length > 1">
      <div class="el-tabs__nav-wrap is-top">
        <div class="el-tabs__nav-scroll">
          <div role="tablist" class="el-tabs__nav is-top is-stretch" style="transform: translateX(0px);">
            <div class="el-tabs__item is-top" :class="rotationType === 'rotation' ? 'is-active' : ''"
              @click="rotationType = 'rotation'">
              Lagerbewegung
            </div>
            <div class="el-tabs__item is-top" :class="rotationType === 'ueber' ? 'is-active' : ''"
              @click="rotationType = 'ueber'">
              Lagerübertragung
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="el-tabs__content">
      <div role="tabpanel" id="pane-Route" aria-labelledby="tab-Route" class="el-tab-pane">
        <transition name="el-fade-in-linear">
          <div v-if="rotationType === 'rotation'">
            <div class="d-flex justify-content-between">
              <h4 class="card-title">Lagerbewegung erfassen</h4>
              <div>
                <fg-input>
                  <l-checkbox v-model="scanmodus" @click="checkRequiredFields"
                    @input="focusProduct">Scanmodus</l-checkbox>
                </fg-input>
              </div>
            </div>
            <form @submit.prevent="submit">
              <div class="row">
                <div class="col-sm-2">
                  <fg-input label="Menge" type="number" v-model.number="stockRotation.quantity"
                    :error="valErrors['quantity'] ? valErrors['quantity'][0] : null" />
                </div>
                <div class="col-sm-5">
                  <div class="form-group has-label">
                    <label>Grund</label>
                    <multiselect v-model="cause" :options="causes" track-by="id" label="name" @input="causeSelected"
                      @select="stockRotation.cause_id ? valErrors['cause_id'] = '' : ''"
                      placeholder="Grund auswählen" />
                    <div class="text-danger invalid-feedback" style="display: block;" v-if="valErrors['cause_id']">
                      Grund muss ausgewählt werden.
                    </div>
                  </div>
                </div>
                <div :class="costCenters.length ? 'col-sm-4' : 'col-sm-5'" v-if="warehouses.length > 1">
                  <div class="form-group has-label">
                    <label>Lager</label>
                    <multiselect v-model="warehouse" :options="warehouses" track-by="id" label="short_name"
                      @input="warehouseSelected"
                      @select="stockRotation.warehouse_id ? valErrors['warehouse_id'] = '' : ''"
                      placeholder="Lager auswählen" />
                    <div class="text-danger invalid-feedback" style="display: block;" v-if="valErrors['warehouse_id']">
                      Lager muss ausgewählt werden.
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="scanmodus">
                <div class="form-group has-label" style="position: relative;">
                  <label>Code</label>
                  <input @keydown.enter.prevent="findProduct" v-model="code" class="form-control" id="product">
                  <i @click="code = null" v-if="code"
                    style="position: absolute; top: 40px; right: 5px; cursor: pointer; color: red;"
                    class="fa fa-solid fa-minus"></i>
                  <div class="text-danger invalid-feedback" style="display: block;" v-if="codeError">
                    Kein/e Produkt/Box für diesen Barcode oder QrCode gefunden
                  </div>
                  <br>
                  <div v-if="showCamera && stockRotation.cause_id && stockRotation.warehouse_id" @click="handleCamera">
                    <button type="button" class="btn btn-fill btn-info"> Kamera öffnen</button>
                  </div>

                  <div v-if="showCamera && allowCamera">
                    <Modal :visible="showModal" @close="showModal = false">
                      <StreamBarcodeReader style="width: 100%; height: 100%;" @decode="onScan"></StreamBarcodeReader>
                    </Modal>
                  </div>

                  <br>
                </div>


              </template>
              <template v-else>
                <product-select :value="product" @input="productSelected" :include-boxes="true"
                  :val-error="valErrors['product_id'] ? valErrors['product_id'][0] : ''" />
              </template>
              <price-input :price="stockRotation.price"
                :label="cause.direction == -1 ? 'Verkaufspreis' : 'Einkaufspreis (netto)'"
                @input="stockRotation.price = $event" v-if="showPrice" />
              <div class="row">

                <div class="col-sm-12" v-if="costCenters.length">
                  <div class="form-group has-label">
                    <label>Kostenstelle</label>
                    <multiselect v-model="costCenter" :options="costCenters" track-by="id" label="name"
                      @input="costCenterSelected" placeholder="Kostenstelle auswählen" />
                  </div>
                </div>
              </div>
              <fg-input label="Kommentar">
                <textarea class="form-control" v-model="stockRotation.comment" rows="3"></textarea>
              </fg-input>
              <button type="submit" class="btn btn-fill btn-info">Erfassen</button>
            </form>
          </div>
          <div v-if="rotationType === 'ueber'">
            <h4 class="card-title">Lagerübertragung erfassen</h4>
            <form @submit.prevent="submitUeber" style="margin-top: 0.75em;">
              <div class="row">
                <div class="col-sm-5">
                  <div class="form-group has-label">
                    <label style="
                      display: flex;
                      justify-content: space-between;
                      align-items: flex-end;
                    ">
                      <div>Von Lager</div>
                      <button class="btn btn-info btn-sm" type="button" v-if="authUserWarehouse"
                        @click="setUserWarehouse('warehouseUeberFrom', warehouseUeberFromSelected)">S</button>
                    </label>
                    <multiselect v-model="warehouseUeberFrom" :options="warehouses" track-by="id" label="short_name"
                      @input="warehouseUeberFromSelected" placeholder="Lager auswählen" />
                    <div class="text-danger invalid-feedback" style="display: block;"
                      v-if="valUeberErrors['warehouse_from_id']">
                      Lager muss ausgewählt werden.
                    </div>
                  </div>
                </div>
                <div class="col-sm-2 text-center"
                  style="padding: 0px;display: flex;justify-content: center;align-items: center;">
                  <button class="btn btn-info" type="button" @click="switchWarehouses">
                    <i class="fas fa-exchange-alt"></i>
                  </button>
                </div>
                <div class="col-sm-5">
                  <div class="form-group has-label">
                    <label style="
                      display: flex;
                      justify-content: space-between;
                      align-items: flex-end;
                    ">
                      <div>Nach Lager</div>
                      <button class="btn btn-info btn-sm" type="button" v-if="authUserWarehouse"
                        @click="setUserWarehouse('warehouseUeberTo', warehouseUeberToSelected)">S</button>
                    </label>
                    <multiselect v-model="warehouseUeberTo" :options="warehouses" track-by="id" label="short_name"
                      @input="warehouseUeberToSelected" placeholder="Lager auswählen" />
                    <div class="text-danger invalid-feedback" style="display: block;"
                      v-if="valUeberErrors['warehouse_to_id']">
                      Lager muss ausgewählt werden.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-9">
                  <product-select :value="productUeber" @input="productUeberSelected" :include-boxes="true"
                    :val-error="valUeberErrors['product_id'] ? valUeberErrors['product_id'][0] : ''" />
                </div>
                <div class="col-sm-2">
                  <fg-input label="Menge" type="number" v-model.number="ueberRotation.quantity"
                    :error="valUeberErrors['quantity'] ? valUeberErrors['quantity'][0] : null" />
                </div>
                <div class="col-sm-1">
                  <button class="btn btn-fill btn-primary" style="margin-top: 2em;" @click.prevent="addUeber">
                    <i class="fas fa-plus" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div class="row" v-for="adddedUeber in ueberRotations"
                :key="`${adddedUeber.type}_${adddedUeber.product_id}`">
                <div class="col-sm-9">{{ adddedUeber.name }}</div>
                <div class="col-sm-2">{{ adddedUeber.quantity }}</div>
                <div class="col-sm-1">
                  <button class="btn btn-link btn-danger" @click.prevent="deleteUeber(adddedUeber)">
                    <i class="fa fa-close"></i>
                  </button>
                </div>
              </div>
              <fg-input label="Kommentar">
                <textarea class="form-control" v-model="ueberRotation.comment" rows="3"></textarea>
              </fg-input>
              <button type="submit" class="btn btn-fill btn-info">Erfassen</button>
            </form>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import ProductSelect from 'src/components/product-select'
import PriceInput from 'src/components/price-input'
import { StreamBarcodeReader } from "vue-barcode-reader";
import Modal from 'src/components/Modal.vue'

export default {
  props: ['initProduct', 'initCauses'],
  components: {
    ProductSelect,
    PriceInput,
    StreamBarcodeReader,
    Modal
  },
  data() {
    return {
      rotationType: 'rotation',
      stockRotation: {
        product_id: null,
        quantity: 1,
        direction: 'in',
        warehouse_id: null,
        cause_id: null,
        cost_center_id: null,
        comment: '',
        price: '',
        batch: null,
        expiry_date: null,
        production_date: null,
        serial_number: null
      },
      product: null,
      warehouse: null,
      cause: null,
      costCenter: null,
      products: [],
      warehouses: [],
      causes: [],
      costCenters: [],
      valErrors: [],
      scanmodus: false,
      code: '',
      codeError: false,
      codeErrorSound: new Audio('/static/beep.wav'),
      codeSuccesSound: new Audio('/static/success.wav'),
      type: 'product',
      box: null,
      ueberRotation: {
        product_id: null,
        quantity: 1,
        warehouse_from_id: this.$store.state.authUser.warehouse_id,
        warehouse_to_id: null,
        comment: ''
      },
      ueberRotations: [],
      productUeber: null,
      warehouseUeberFrom: this.$store.state.authUser.warehouse || null,
      warehouseUeberTo: null,
      valUeberErrors: [],
      warehousesUeberFrom: [],
      warehousesUeberTo: [],
      authUserWarehouse: this.$store.state.authUser.warehouse,
      isFrontdesk: this.$store.getters.isFrontdesk,
      showCamera: false,
      allowCamera: false,
      user: {},
      showModal: false,
      gsObj: { gtin: null, batch: null, expiry_date: null, production_date: null, serial_number: null },
      isGS1: false
    }
  },
  watch: {
    initProduct(newProduct, oldProduct) {
      this.productSelected(newProduct)
      this.productUeberSelected(newProduct)
    },
    initCauses(newCauses, oldCauses) {
      // deselect cause if other direction
      if (this.cause && newCauses && newCauses.length > 0) {
        if (this.cause.direction !== newCauses[0].direction) {
          this.cause = null
          this.stockRotation.cause_id = null
        }
      }
      this.causes = newCauses
    }
  },
  computed: {
    showPrice() {
      const causeHasPrice = this.cause && this.cause.has_price
      // frontdesk must not see einkaufspreis
      if (this.isFrontdesk) {
        return causeHasPrice && this.cause.direction === -1
      }
      return causeHasPrice
    }
  },
  methods: {
    onScan(result) {
      this.code = result
      this.findProductCode(result)
    },
    handleCamera() {
      this.allowCamera = true;
      this.showModal = true;
    },
    checkRequiredFields() {

      this.checkScreen()
      if (!this.stockRotation.cause_id) {
        this.valErrors['cause_id'] = "Grund muss ausgefüllt werden"
        this.allowCamera = false;
      } else {
        this.valErrors['cause_id'] = '';
      }
      if (!this.stockRotation.warehouse_id) {
        this.valErrors['warehouse_id'] = "Grund muss ausgefüllt werden"
        this.allowCamera = false;
      } else {
        this.allowCamera = true;
        this.valErrors['warehouse_id'] = '';
      }
    },
    focusProduct() {
      if (this.scanmodus) {
        this.$nextTick(() => { document.getElementById('product').focus() })
        this.checkScreen()
      }
    },
    submit() {
      if (this.type === 'product') {
        this.submitProduct()
      } else {
        this.submitBox()
      }
    },
    async submitProduct() {
      await this.initCsrf()

      this.$http.post(`/stock_rotations`, this.stockRotation).then(({ data }) => {
        this.resetStockRotation()
        this.$notify({
          message: 'Die Lagerbewegung wurde erfolgreich erfasst.',
          type: 'success'
        })
        this.$emit('stockRotationsCreated', data)
        this.focusProduct()
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    async submitBox() {
      await this.initCsrf()

      this.$http.post(`/boxes/${this.box}/stock_rotations`, this.stockRotation).then(({ data }) => {
        this.resetStockRotation()
        this.$notify({
          message: 'Die Lagerbewegungen wurde erfolgreich erfasst.',
          type: 'success'
        })
        this.$emit('stockRotationsCreated', data)
        this.focusProduct()
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    setStockRotationPrice(product, cause) {
      if (+cause.direction === -1) {
        this.stockRotation.price = product ? product.price : ''
      } else if (+cause.direction === 1) {
        this.stockRotation.price = product ? product.einkaufspreis : ''
      } else {
        this.stockRotation.price = ''
      }
    },
    productSelected(product) {
      this.product = product
      if (product) {
        if (product.isBoxModel) {
          this.type = 'box'
          this.box = product.id
        } else {
          this.type = 'product'
          this.stockRotation.product_id = product ? product.id : null

          if (this.cause && this.cause.has_price) {
            this.setStockRotationPrice(product, this.cause)
          } else {
            this.stockRotation.price = ''
          }
        }
      }
    },
    warehouseSelected(warehouse) {
      this.stockRotation.warehouse_id = warehouse ? warehouse.id : null
    },
    causeSelected(cause) {
      this.stockRotation.cause_id = cause ? cause.id : null
      if (cause && cause.has_price && this.product) {
        this.setStockRotationPrice(this.product, cause)
      } else {
        this.stockRotation.price = ''
      }
    },
    costCenterSelected(costCenter) {
      this.stockRotation.cost_center_id = costCenter ? costCenter.id : null
    },
    resetStockRotation() {
      this.type = 'product'
      this.product = null
      this.box = null
      this.code = ''
      this.stockRotation.product_id = ''
      this.stockRotation.comment = ''
      this.stockRotation.quantity = 1
      this.stockRotation.price = ''
      this.stockRotation.batch = ''
      this.stockRotation.expiry_date = ''
      this.stockRotation.production_date = ''
      this.stockRotation.serial_number = null
      this.valErrors = []
      this.gsObj = { gtin: null, batch: null, expiry_date: null, production_date: null, serial_number: null }
    },
    async findProduct(e) {
      this.codeError = false;
      this.isGS1 = false;
      const barcodeValue = e.target.value;

      const gs1Patterns = ['10', '17', '11', '21'];

      if (barcodeValue.startsWith('01')) {
        const gtin = barcodeValue.substring(2, 16);

        if (/^\d{14}$/.test(gtin)) {
          const remainingData = barcodeValue.substring(16);

          if (gs1Patterns.some(pattern => remainingData.startsWith(pattern))) {
            this.isGS1 = true;
          }
        }
      }

      if (this.isGS1) {
        try {
          const { data } = await this.$http.get(`/product/decode/${barcodeValue}`);
          this.identifiers = data.identifiers;
        } catch (error) {
          console.error("Error fetching identifiers:", error);
          this.codeError = true;
          throw error;
        }

        Object.entries(this.identifiers).forEach(([key, item]) => {
          if (key === "01") this.gsObj.gtin = item.content;
          if (key === "10") this.gsObj.batch = item.content;
          if (key === "17") this.gsObj.expiry_date = item.raw_content;
          if (key === "11") this.gsObj.production_date = item.raw_content;
          if (key === "21") this.gsObj.serial_number = item.raw_content;
        });

        e.target.value = this.gsObj.gtin;
      }

      await this.$http.get(`/products/code/${encodeURIComponent(e.target.value)}`).then(({ data }) => {
        if (data.type === 'product') {
          this.type = 'product';
          this.stockRotation.product_id = data.product.id;
          if (this.cause && this.cause.has_price) {
            this.setStockRotationPrice(data.product, this.cause);
          }
          if (this.isGS1) {
            data.product.barcode_type = 'gs1-128';
            this.$http.put(`/products/${data.product.id}`, data.product);
            this.stockRotation.batch = this.gsObj.batch;
            this.stockRotation.expiry_date = this.gsObj.expiry_date;
            this.stockRotation.production_date = this.gsObj.production_date;
            this.stockRotation.serial_number = this.gsObj.serial_number;
          }
          this.submit();
        } else {
          this.type = 'box';
          this.box = data.box.id;
          this.submitBox();
        }
      }).catch(({ response }) => {
        this.codeError = true;
        this.codeErrorSound.play();
      });
    },

    async findProductCode(code) {
      this.codeError = false;
      this.isGS1 = false;
      const barcodeValue = e.target.value;

      const gs1Patterns = ['10', '17', '11', '21'];

      if (barcodeValue.startsWith('01')) {
        const gtin = barcodeValue.substring(2, 16);

        if (/^\d{14}$/.test(gtin)) {
          const remainingData = barcodeValue.substring(16);

          if (gs1Patterns.some(pattern => remainingData.startsWith(pattern))) {
            this.isGS1 = true;
          }
        }
      }

      if (this.isGS1) {
        try {
          const { data } = await this.$http.get(`/product/decode/${barcodeValue}`);
          this.identifiers = data.identifiers;
        } catch (error) {
          console.error("Error fetching identifiers:", error);
          this.codeError = true;
          throw error;
        }

        Object.entries(this.identifiers).forEach(([key, item]) => {
          if (key === "01") this.gsObj.gtin = item.content;
          if (key === "10") this.gsObj.batch = item.content;
          if (key === "17") this.gsObj.expiry_date = item.raw_content;
          if (key === "11") this.gsObj.production_date = item.raw_content;
          if (key === "21") this.gsObj.serial_number = item.raw_content;
        });

        e.target.value = this.gsObj.gtin;
      }

      this.$http.get(`/products/code/${encodeURIComponent(code)}`).then(({ data }) => {
        if (data.type === 'product') {
          this.type = 'product';
          this.stockRotation.product_id = data.product.id;

          if (this.cause && this.cause.has_price) {
            this.setStockRotationPrice(data.product, this.cause);
          }

          if (this.isGS1) {
            data.product.barcode_type = 'gs1-128';
            this.$http.put(`/products/${data.product.id}`, data.product);
            this.stockRotation.batch = this.gsObj.batch;
            this.stockRotation.expiry_date = this.gsObj.expiry_date;
            this.stockRotation.production_date = this.gsObj.production_date;
            this.stockRotation.serial_number = this.gsObj.serial_number;
          }

          this.submit();
        } else {
          this.type = 'box';
          this.box = data.box.id;
          this.submitBox();
        }

        this.allowCamera = false;
        if (this.user.enable_sound) {
          this.codeSuccesSound.play();
        }
      }).catch(({ response }) => {
        this.codeError = true;
        this.codeErrorSound.play();
      });
    },
    productUeberSelected(product) {
      this.productUeber = product
      if (product) {
        if (product.isBoxModel) {
          this.ueberType = 'box'
        } else {
          this.ueberType = 'product'
        }
        this.ueberRotation.product_id = product ? product.id : null
      }
    },
    warehouseUeberFromSelected(warehouse) {
      this.ueberRotation.warehouse_from_id = warehouse ? warehouse.id : null
      // if (warehouse) {
      //   this.warehousesUeberTo = this.warehouses.filter(wh => warehouse.id !== wh.id)
      // } else {
      //   this.warehousesUeberTo = []
      //   this.ueberRotation.warehouse_to_id = null
      //   this.warehouseUeberTo = null
      // }
    },
    warehouseUeberToSelected(warehouse) {
      this.ueberRotation.warehouse_to_id = warehouse ? warehouse.id : null
    },
    async submitUeber() {
      this.addUeber()

      await this.initCsrf()
      this.$http.post(`/stock_rotations/ueber`, {
        warehouse_from_id: this.ueberRotation.warehouse_from_id,
        warehouse_to_id: this.ueberRotation.warehouse_to_id,
        products: this.ueberRotations,
        comment: this.ueberRotation.comment
      }).then(({ data }) => {
        this.productUeber = null
        this.ueberRotation.product_id = ''
        this.ueberRotation.comment = ''
        this.ueberRotation.quantity = 1
        this.ueberRotations = []
        this.valErrors = []
        this.$notify({
          message: 'Die Lagerübertragungen wurden erfolgreich erfasst.',
          type: 'success'
        })
        this.$emit('stockRotationsCreated', ...data)
      }).catch(({ response }) => { this.valUeberErrors = response.data.errors })
    },
    addUeber() {
      if (this.productUeber && this.ueberRotation.quantity) {
        const type = this.productUeber.isBoxModel ? 'box' : 'product'
        const index = this.findUeberProduct(this.ueberRotation.product_id, type)
        if (index >= 0) {
          this.ueberRotations[index].quantity += this.ueberRotation.quantity
        } else {
          this.ueberRotations.push({
            name: this.productUeber.name,
            product_id: this.ueberRotation.product_id,
            quantity: this.ueberRotation.quantity,
            type
          })
        }
        this.productUeber = null
        this.ueberRotation.product_id = ''
        this.ueberRotation.quantity = 1
      }
    },
    deleteUeber(ueber) {
      this.ueberRotations.splice(this.findUeberProduct(ueber.product_id, ueber.type), 1)
    },
    findUeberProduct(id, type) {
      return this.ueberRotations.findIndex(rot => (rot.product_id === id && rot.type === type))
    },
    setUserWarehouse(warehouseToSet, warehouseSelected) {
      this[warehouseToSet] = this.authUserWarehouse
      warehouseSelected(this.authUserWarehouse)
    },
    switchWarehouses() {
      const from = this.warehouseUeberFrom
      const to = this.warehouseUeberTo
      this.warehouseUeberFrom = to
      this.warehouseUeberFromSelected(to)
      this.warehouseUeberTo = from
      this.warehouseUeberToSelected(from)
    },
    checkScreen() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return this.showCamera = true
      } else {
        return this.showCamera = false
      }


    }
  },
  created() {
    this.checkScreen()
    this.$http.get(`/users/${this.$store.state.authUser.id}`).then(({ data }) => {
      this.user = data
    })
    if (!this.initCauses) {
      this.$http.get(`/causes?only_selectable=1`).then(({ data }) => {
        this.causes = data
      })
    }
    this.$http.get(`/cost_centers`).then(({ data }) => {
      this.costCenters = data
    })
    this.$http.get(`/warehouses`).then(({ data }) => {
      if (data.length === 1) {
        this.stockRotation.warehouse_id = data[0].id
      } else {
        this.stockRotation.warehouse_id = this.$store.state.authUser.warehouse_id
        this.warehouse = this.$store.state.authUser.warehouse
      }
      this.warehouses = data
    })
  }
}
</script>

<style></style>
